import {css} from '../emotion';
import {
  mediumVars,
  xLargeVars,
  xLargeBrandedVars,
} from '@packages/utilities/styled-tokens';

/**
 * This is its own file because the `css` function throws errors if we import it directly into SizeContext. ¯\_(ツ)_/¯
 */

const SIZE_CLASSES = {
  medium: css(mediumVars),
  'x-large': css(xLargeVars),
  'x-large-branded': css(xLargeBrandedVars),
};

export const getSizeClasses = ({
  size,
}: {
  size: 'medium' | 'x-large' | 'x-large-branded';
  /**
   * To support the new Marketplace D2 aesthetics.
   * 2024-03-07
   */
  isMarketplace?: boolean;
}) => {
  return SIZE_CLASSES[size];
};
